<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main" style="background-color: #fff; padding: 20px 0; min-height: 500px;">
					<div class="login_main">
						<el-row>
							<el-col :span="4">
								<UserLeft></UserLeft>
							</el-col>
							<el-col :span="20">
								
								<div class="neirong_line_region" style="margin-top: 20px; margin-bottom: 30px;">
									<el-breadcrumb separator-class="el-icon-arrow-right">
									  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
									  <el-breadcrumb-item>控制台</el-breadcrumb-item>
									  <el-breadcrumb-item>我的发票</el-breadcrumb-item>
									</el-breadcrumb>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_title" style="font-size: 14px;">
										<el-row>
											<el-col :span="4">消费总额：{{fapiaoEdu.paymentSum}}</el-col>
											<el-col :span="4">已开票额度：{{fapiaoEdu.invoiceSum}}</el-col>
											<el-col :span="4">可开票额度：{{fapiaoEdu.kekaiSum}}</el-col>
											<el-col :span="4" :offset="8" style="text-align: right;">
												<el-button type="primary" plain size="mini" v-if="fapiaoEdu.kekaiSum > 0" @click="kaipiao()"> 申请开票 </el-button>
											</el-col>
										</el-row>
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_title" style="font-weight: bold;">
										<!-- <div class="neirong_line_title_icon"></div> -->
										<el-row>
											<el-col :span="4">发票抬头</el-col>
											<el-col :span="3">信用代码</el-col>
											<el-col :span="4">地址、电话</el-col>
											<el-col :span="4">开户行及账号</el-col>
											<el-col :span="3">发票备注</el-col>
											<el-col :span="3">收票邮箱</el-col>
											<el-col :span="3">是否开票</el-col>
										</el-row>
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								<el-empty description="没有开票记录..." v-show="is_show_empty"></el-empty>
								
								<div class="neirong_line_region" v-for="(item, index) in list_record">
									<div class="neirong_line_title" style="height: auto;">
										<!-- <div class="neirong_line_title_icon"></div> -->
										<el-row>
											<el-col :span="4"><div style="font-size: 13px; line-height: 15px; width: 90%; overflow-wrap: break-word;">{{item.taitou}}</div>&nbsp;</el-col>
											<el-col :span="3"><div style="font-size: 13px; line-height: 15px; width: 80%; overflow-wrap: break-word;">{{item.creditCode}}</div>&nbsp;</el-col>
											<el-col :span="4"><div style="font-size: 13px; line-height: 15px; width: 90%; overflow-wrap: break-word;">{{item.addrMobi}}</div>&nbsp;</el-col>
											<el-col :span="4"><div style="font-size: 13px; line-height: 15px; width: 90%; overflow-wrap: break-word;">{{item.bankAccount}}</div>&nbsp;</el-col>
											<el-col :span="3"><div style="font-size: 13px; line-height: 15px; width: 90%; overflow-wrap: break-word;">{{item.remark}}</div>&nbsp;</el-col>
											<el-col :span="3"><div style="font-size: 13px; line-height: 15px; width: 90%; overflow-wrap: break-word;">{{item.email}}</div>&nbsp;</el-col>
											<el-col :span="3" v-if="item.dictSfkp == 0"><el-tag type="info" size="mini">未开票</el-tag></el-col>
											<el-col :span="3" v-if="item.dictSfkp == 1"><el-tag type="success" size="mini">已开票</el-tag></el-col>
										</el-row>
									</div>
									<div class="neirong_line_summary" v-if="item.dictSfkp != 1">
										<el-popconfirm title="确定要撤销发票申请吗？" @confirm="remove(item.id)">
											<el-button type="primary" plain round size="mini" icon="el-icon-close" slot="reference">撤销申请</el-button>
										</el-popconfirm>
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_page" style="text-align: center;">
									<el-pagination
									  background
									  layout="prev, pager, next, jumper"
									  :total="total"
									  @current-change="handlePage"
									  >
									</el-pagination>
								</div>
								
							</el-col>
						</el-row>
					</div>
				</div>
				
				
				
				<el-dialog
				  title="申请开票"
				  :visible.sync="kaipiaoDialog"
				  width="30%">
				  <span>
					  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						  <el-form-item label="开票金额" prop="amount">
							<el-input v-model="ruleForm.amount" :readonly="true"></el-input>
						  </el-form-item>
						  <el-form-item label="发票抬头" prop="taitou">
							<el-input v-model="ruleForm.taitou" placeholder="收票方企业名称"></el-input>
						  </el-form-item>
						  <el-form-item label="信用代码" prop="creditCode">
							<el-input v-model="ruleForm.creditCode" placeholder="收票方信用代码"></el-input>
						  </el-form-item>
						  <el-form-item label="地址、电话" prop="addrMobi">
							<el-input v-model="ruleForm.addrMobi"></el-input>
						  </el-form-item>
						  <el-form-item label="开户行及账号" prop="bankAccount">
							<el-input v-model="ruleForm.bankAccount"></el-input>
						  </el-form-item>
						  <el-form-item label="发票备注" prop="remark">
							<el-input v-model="ruleForm.remark"></el-input>
						  </el-form-item>
						  <el-form-item label="接收邮箱" prop="email">
							<el-input v-model="ruleForm.email" placeholder="接收发票的电子邮箱"></el-input>
						  </el-form-item>
						  <el-form-item label="开票联系人" prop="contact">
							<el-input v-model="ruleForm.contact" placeholder="开票过程中可以联系到的负责人和联系电话"></el-input>
						  </el-form-item>
				
						  <el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')" :disabled="btnKaipiao">申请开票</el-button>
							<el-button @click="kaipiaoDialog = false">取消</el-button>
						  </el-form-item>
					  </el-form>
				  </span>
				  <!-- <span slot="footer" class="dialog-footer">
				    <el-button @click="kaipiaoDialog = false">取 消</el-button>
				    <el-button type="primary" @click="kaipiaoSubmit">确 定</el-button>
				  </span> -->
				</el-dialog>
				
				
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import UserLeft from '../components/userLeft.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			UserLeft,
		},
		data() {
			return {
				cur_user: {},
				is_show_empty: false,
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				fapiaoEdu: {invoiceSum: 0, paymentSum: 0, kekaiSum: 0},
				
				kaipiaoDialog: false,
				
				ruleForm: {
					userId: 0,
					userName: '',
					amount: '',
					taitou: '',
					creditCode: '',
					addrMobi: '',
					bankAccount: '',
					remark: '',
					email: '',
					contact: '',
				},
				rules: {
					amount: [
						{required: true, message: '开票金额必填', trigger: 'blur'}
					],
					taitou: [
						{required: true, message: '请填写发票抬头，如果是企业填写企业名称，如果是个人填写姓名', trigger: 'blur'}
					],
					creditCode: [
						{required: true, message: '请填写信用代码，如果是企业填写信用代码，如果是个人填写身份证号', trigger: 'blur'}
					],
					email: [
						{required: true, message: '请填写接收电子发票的电子邮箱', trigger: 'blur'}
					],
					contact: [
						{required: true, message: '请填写开票过程中可以联系到的负责人和联系电话', trigger: 'blur'}
					]
				},
				btnKaipiao: false,
				
			}
		},
		
		created() {
			// console.log('用户状态已保存1', localStorage.getItem('cur_user'))
			// console.log('用户状态已保存2', JSON.parse(localStorage.getItem('cur_user')))
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
			// console.log(this.cur_user);
			if (this.cur_user == null || this.cur_user == {}) {
				this.$message({
					message: '未登录用户，请登陆后进入控制台',
					type: 'error',
				});
				setTimeout(()=>{
					this.toUrlCur('login')
				}, 1500)
			} else {
				this.loadData();
				this.loadFapiaoEdu();
			}
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			toUrlCur(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 加载数据
			loadData() {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				let url = this.$common.apiUrl + 'pub_user_invoice/listByUserId'
				let client_data = this.$qs.stringify({userId: this.cur_user.id, pi: this.pi})
				this.$axios.post(url, client_data).then((res)=>{
					// console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
				})
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.pi = 1
					this.loadData()
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.loadData()
				document.documentElement.scrollTop = 0;
			},
			
			// 删除
			remove(id) {
				let url = this.$common.apiUrl + 'pub_user_invoice/remove'
				let client_data = this.$qs.stringify({id: id})
				this.$axios.post(url, client_data).then((res)=>{
					this.$message.info('已撤销')
					// this.loadData()
					setTimeout(()=>{
						window.location.reload();
					}, 800)
				})
			},
			
			
			// 加载发票额度
			loadFapiaoEdu() {
				let url = this.$common.apiUrl + 'pub_user_invoice/statisPaymentInvoice'
				let client_data = this.$qs.stringify({userId: this.cur_user.id})
				this.$axios.post(url, client_data).then((res)=>{
					// console.log(res.data.data)
					this.fapiaoEdu = res.data.data
					if (this.fapiaoEdu.kekaiSum > 0) {
						this.ruleForm.amount = this.fapiaoEdu.kekaiSum;
					}
				})
			},
			
			// 点击申请开票按钮
			kaipiao() {
				this.kaipiaoDialog = true;
			},
			
			// 提交开票申请
			kaipiaoSubmit() {
				let url = this.$common.apiUrl + 'pub_user_invoice/kaipiao'
				this.ruleForm.userId = this.cur_user.id
				this.ruleForm.userName = this.cur_user.openidmp
				let client_data = this.$qs.stringify(this.ruleForm)
				this.$axios.post(url, client_data).then((res)=>{
					// console.log(res.data.data)
					this.$message.success('开票申请提交成功');
					setTimeout(()=>{
						window.location.reload();
					}, 800)
				})
			},
			
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					// alert('submit!');
					this.btnKaipiao = true;
					this.kaipiaoSubmit(); // 提交开票申请
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
			
			
			
		}
	}
</script>

<style scoped>
	.neirong_line_region {
		/* border: 1px solid red; */
		width: 93%;
		padding: 0px 4%;
		margin-left: 2%;
	}
	
	.neirong_line_summary {
		text-align: right;
	}
	
	.neirong_line_title {
		font-size: 14px;
	}
</style>